import styles from './HeroBanner.module.scss';
import { Typography } from '@mui/material';
//mui
import { styled } from '@mui/material/styles';

export default function HeroBanner({
  heroImg,
  showBlur = false,
  MainTitle,
  subTitle,
}) {
  const StyledBackground = styled('div')(() => ({
    'backgroundImage': `url(${heroImg.src})`,
    '&:after': {
      display: showBlur ? 'block' : 'none',
    },
  }));

  return (
    <StyledBackground className={styles.bannerwrapper}>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerContentArea}>
          <Typography variant="h5" color="primary.white">
            {subTitle}
          </Typography>
          <Typography variant="h1" color="primary.white">
            {MainTitle}
          </Typography>
        </div>
      </div>
    </StyledBackground>
  );
}
